(() => {
const ALLOWED_HOSTS = new Set(['gopryme.com','www.gopryme.com','swisse.com.sg','elitesupps.sg','estalife.com','xandrolab.com','onflowlab.com','www.pipingrock.com','pipingrock.com','goli.com','www.goli.com','www.watsons.com.sg']);

function normaliseProductUrl(input) {
  if (typeof input !== 'string' || input.length > 2048) throw new Error('Enter a product-page link under 2,048 characters.');
  let url;
  try { url = new URL(input.trim()); } catch { throw new Error('Enter a complete product link beginning with https://.'); }
  if (url.protocol !== 'https:' || url.username || url.password || (url.port && url.port !== '443')) throw new Error('Use a public https:// product link without sign-in details or a custom port.');
  if (!ALLOWED_HOSTS.has(url.hostname)) throw new Error('This website is not supported yet. Choose a supported seller below, or paste its label text to extract the available details.');
  const path = decodeURIComponent(url.pathname);
  const productPath = /^(?:\/[a-z]{2}(?:-[A-Z]{2})?)?\/(?:collections\/[^/]+\/)?products\/[^/]+\/?$/;
  const watsonsPath = url.hostname === 'www.watsons.com.sg' && /^\/[^/]+\/p\/BP_\d+$/.test(path);
  if ((!productPath.test(path) && !watsonsPath) || /[\\\u0000-\u001f]/.test(path)) throw new Error('Use the individual product page, rather than a home, collection or account page.');
  if (/pipingrock/.test(url.hostname) && !path.startsWith('/en-SG/products/')) throw new Error('Use Piping Rock’s Singapore product link beginning /en-SG/products/ so the currency is clear.');
  const variant = url.searchParams.get('variant');
  if (variant && !/^\d{1,20}$/.test(variant)) throw new Error('The product variant in this link is not valid. Remove the query string and try again.');
  url.search = ''; if (variant) url.searchParams.set('variant',variant);
  url.hash = '';
  return url;
}

function productKey(input) {
  const u = new URL(input);
  return u.hostname.replace(/^www\./,'') + decodeURIComponent(u.pathname).replace(/\/collections\/[^/]+(?=\/products\/)/,'').replace(/\/$/,'').toLowerCase();
}

function plainText(raw) {
  return String(raw || '').replace(/<!--[\s\S]*?-->/g,' ').replace(/<(script|style|svg)\b[^>]*>[\s\S]*?<\/\1>/gi,' ')
    .replace(/<(?:br|\/p|\/div|\/li|\/tr|\/td|\/th|\/h[1-6]|\/summary|\/details)[^>]*>/gi,'\n')
    .replace(/<[^>]+>/g,' ').replace(/&nbsp;|&#160;/g,' ').replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,'"').replace(/&#39;|&apos;/g,"'")
    .replace(/&#(\d+);/g,(_,code)=>{const n=Number(code);return n>0&&n<=0x10ffff?String.fromCodePoint(n):'';})
    .replace(/[ \t]+/g,' ').replace(/ *\n */g,'\n').replace(/\n{3,}/g,'\n\n').trim();
}

function walkProducts(value, found = [], depth = 0) {
  if (depth > 12 || !value || typeof value !== 'object') return found;
  if (Array.isArray(value)) { for (const item of value.slice(0,100)) walkProducts(item,found,depth+1); return found; }
  if (value['@type'] === 'Product' || (Array.isArray(value['@type']) && value['@type'].includes('Product'))) found.push(value);
  if (value['@graph']) walkProducts(value['@graph'],found,depth+1);
  if (value.mainEntity) walkProducts(value.mainEntity,found,depth+1);
  return found;
}

function getStructuredProduct(raw, url) {
  const candidates=[];
  const pattern=/<script\b[^>]*type\s*=\s*["']application\/ld\+json["'][^>]*>([\s\S]*?)<\/script>/gi;
  let match, count=0;
  while ((match=pattern.exec(raw)) && count++<30) {
    if (match[1].length>300000) continue;
    try { walkProducts(JSON.parse(match[1]),candidates); } catch { /* Malformed third-party JSON is optional evidence. */ }
  }
  const target=productKey(url);
  return candidates.filter(p=>typeof p.name==='string').sort((a,b)=>{
    const score=p=>{try{return (p.url&&productKey(p.url)===target?10:0)+(p.offers?2:0)+(p.description?1:0);}catch{return 0;}};
    return score(b)-score(a);
  })[0] || null;
}

function numberFromText(value) {
  const words={one:1,two:2,three:3,four:4,five:5,six:6};
  return words[String(value).toLowerCase()] || Number(value);
}

function extractLabelText(input, title='') {
  const text=plainText(input).replace(/\[(?:section break|benefits|directions|detailed_ingredients)\]/gi,'\n').slice(0,60000);
  const lines=text.split('\n').map(x=>x.trim()).filter(Boolean);
  const warningHeading=/^(?:warnings?\b|caution\b|precautions?\b|pregnancy\s*:|breastfeeding\s*:|diabetic\s*:|interactions\b|contraindications\b)/i;
  const boundary=/^(?:warnings?\b|caution\b|precautions?\b|pregnancy\s*:|breastfeeding\s*:|diabetic\s*:|interactions\b|contraindications\b|storage\b|store\s|directions\b|adult dosage|suggested use|how to use\b|results timeline\b|real results\b|gallery$|clean formulation\b|allergen information\b|the difference\b|other ingredients\b|supplement facts$|ingredients$|each .*contains\s*:?$|quality\b|benefits\b|key benefits\b|no added\b|vegan\b|why .+\?|what .+\?|product information last reviewed|the facts behind|frequently asked|customer reviews|related products)/i;
  const sectionAt=(index,max=800)=>{
    if(index<0)return null;
    const result=[lines[index]];
    for(let i=index+1;i<Math.min(index+12,lines.length);i++){
      if(boundary.test(lines[i]))break;
      result.push(lines[i]);
    }
    const joined=result.join('\n');return joined.length>max?joined.slice(0,max)+'… (see source for the full text)':joined;
  };
  const lineFor=(pattern,max=800)=>sectionAt(lines.findIndex(line=>pattern.test(line)),max);
  const serving=lineFor(/^(?:suggested (?:use|usage)|directions(?: for use)?|adult dosage|recommended (?:use|dosage)|how to use|take\s+(?:\d|one|two|three)|chew\s+\d)/i,700);
  const directions=serving || (text.match(/(?:take|chew)\s+(?:\d+(?:\.\d+)?|one|two|three|four)\s+(?:vegan |vegetable |film.coated )?(?:capsules?|tablets?|gummies)\b[^.\n]{0,140}/i)||[])[0] || null;
  const dose=String(directions||'').match(/(?:take|chew)\s+(\d+(?:\.\d+)?|one|two|three|four)\s+(?:vegan |vegetable |film.coated )?(capsules?|tablets?|gummies)\b[^\n]{0,60}?\b(?:daily|a day|per day|once daily)\b/i);
  const daily=dose&&!/\b(?:twice|three times|two times|[2-9] times)\b/i.test(directions)?numberFromText(dose[1]):null;
  const pack=(`${title}\n${text}`).match(/\b(\d{1,4})\s*(?:vegan |vegetable |veg |film.coated )?(capsules?|tablets?|gummies)\b/i);
  const units=pack&&Number(pack[1])>=5?Number(pack[1]):null;
  const unit=(pack?.[2]||dose?.[2]||'units').toLowerCase();
  const ingredientIndex=lines.findIndex(line=>/^(?:active ingredients|supplement facts|full list of ingredients|ingredients|each (?:capsule|tablet|serving)|per serving|amount per serving)/i.test(line));
  const ingredientLines=[];
  if(ingredientIndex>=0)for(let i=ingredientIndex;i<Math.min(ingredientIndex+55,lines.length);i++){
    if(i>ingredientIndex&&/^(?:other ingredients|warnings?|caution|directions|suggested use|how to use|results timeline|real results|gallery$|clean formulation|allergen information|the difference|quality\b|key benefits|storage|store |customer reviews|shipping|related products)/i.test(lines[i]))break;
    ingredientLines.push(lines[i]);
  }
  const ingredientText=ingredientLines.join('\n').slice(0,2200);
  const ingredients=ingredientText&&!/^(?:active ingredients|supplement facts|full list of ingredients|ingredients)\s*:?\s*$/i.test(ingredientText)?ingredientText:null;
  const other=lineFor(/^other ingredients\s*:?/i,600);
  const warnings=lines.map((line,index)=>warningHeading.test(line)?sectionAt(index,1600):null).filter(Boolean).join('\n\n').slice(0,3000)||null;
  const storageIndex=lines.findIndex(line=>/^stor(?:e|age)\b/i.test(line));
  const storage=storageIndex<0?(text.match(/\bStore\s+[^.!?\n]*(?:[.!?]|$)/i)||[])[0]||null:/^store\s/i.test(lines[storageIndex])?lines[storageIndex]:sectionAt(storageIndex,600);
  return {title:title||null,units,daily,unit,directions,ingredients,other,warnings,storage};
}

function selectOffer(structured, requestedVariant) {
  let offers=structured?.offers;
  if (!offers) return null;
  if (!Array.isArray(offers)) offers=[offers];
  offers=offers.filter(x=>x&&typeof x==='object');
  if (requestedVariant) {
    const selected=offers.find(x=>{try{return new URL(x.url).searchParams.get('variant')===requestedVariant;}catch{return false;}});
    if (selected) return selected;
    return null;
  }
  return offers.find(x=>x.price!==undefined&&x.priceCurrency) || null;
}

function assembleResult({url,raw='',product=null,reviewed=null,fetchFailed=false}) {
  const u=new URL(url); const requestedVariant=u.searchParams.get('variant');
  const structured=getStructuredProduct(raw,url);
  let variants=Array.isArray(product?.variants)?product.variants.slice(0,40):[];
  const oneTime=reviewed?.id==='onflow'?variants.find(v=>/one time purchase/i.test(v.title)):null;
  const selected=requestedVariant?variants.find(v=>String(v.id)===requestedVariant):(oneTime||variants[0]);
  if (requestedVariant&&variants.length&&!selected) throw new Error('That variant is no longer listed. Remove ?variant= from the link and try again.');
  const name=plainText(product?.title||structured?.name||reviewed?.name||'').slice(0,180);
  const description=product?.description||structured?.description;
  const label=extractLabelText(description||(!reviewed?raw:''),name);
  // Reviewed labels already have their formula and serving. Avoid reparsing an entire
  // storefront just to fill optional fields, and leave absent warnings open to review.
  if(!reviewed&&description){
    const fullLabel=extractLabelText(raw,name);
    for (const key of ['ingredients','other','warnings','storage','directions']) if(!label[key])label[key]=fullLabel[key];
    if(!label.units)label.units=fullLabel.units;if(!label.daily)label.daily=fullLabel.daily;
  }
  const pageCurrency=(raw.match(/Shopify\.currency\s*=\s*\{[^}]*"active"\s*:\s*"([A-Z]{3})"/)||[])[1]||null;
  const offer=selectOffer(structured,requestedVariant);
  let currency=offer?.priceCurrency||pageCurrency||null;
  let price=offer&&Number.isFinite(Number(offer.price))?Number(offer.price):null;
  let priceSource=price!==null?'Product-page offer':'';
  if(selected && pageCurrency && !/pipingrock/.test(u.hostname)){
    currency=pageCurrency;price=Number(selected.price)/100;priceSource='Product data for the selected variant';
  }
  if(price!==null&&(!Number.isFinite(price)||price<0))price=null;
  const notes=[];
  let units=label.units,daily=label.daily,unit=label.unit;
  if(selected?.title){const optionPack=extractLabelText('',selected.title);if(optionPack.units){units=optionPack.units;unit=optionPack.unit;}}
  if(reviewed){
    units=reviewed.units;daily=reviewed.daily;unit=reviewed.unit;
    const bundle=selected?.title?.match(/^(\d+)\s*bottles?\b/i);
    if(bundle&&Number(bundle[1])>1&&units)units*=Number(bundle[1]);
    else if(selected&&selected!==variants[0]&&reviewed.id==='onflow'&&!/one time purchase|1 month supply/i.test(selected.title)) units=null;
    notes.push(`Formula and pack details: GOPRYME editorial review dated ${reviewed.reviewedAt}. Check the current bottle for changes.`);
  }
  if(reviewed?.id==='xandro')notes.push('Xandro may display additional page promotions. This live reader uses the price exposed by its product data; the comparison table separately identifies its dated promotional offer.');
  if(reviewed?.id==='pipingrock')notes.push('Price uses the Singapore-facing page offer; the separate product-data endpoint can return a different regional amount.');
  if(fetchFailed)notes.push('The seller could not be read live. Showing the dated reviewed specifications only; current price and availability are left open.');
  if(!reviewed)notes.push('Automatically extracted from the seller’s text. Review the serving, units and ingredients before using the calculation.');
  const available=fetchFailed?null:(typeof selected?.available==='boolean'?selected.available:(offer?.availability?/InStock$/.test(offer.availability):null));
  const sourceLinks=reviewed?.sourceUrls||[url];
  const fields={
    name:name||null,brand:product?.vendor||structured?.brand?.name||reviewed?.brand||null,
    ingredients:reviewed?.actives||label.ingredients,otherIngredients:reviewed?.other||label.other,
    functions:reviewed?.functions||null,directions:reviewed?.directions||label.directions,
    warnings:label.warnings,storage:label.storage,format:reviewed?.form||null,
    quality:reviewed?.quality||null,sugar:reviewed?.sugar||null,
    price:fetchFailed?null:price,currency:currency||reviewed?.currency||null,units,daily,unit,
    shipping:reviewed?.brand==='GOPRYME'?0:null,available
  };
  const missing=[];
  if(fields.price===null)missing.push('Current price');if(!fields.currency)missing.push('Price currency');
  if(!units)missing.push('Exact pack count');if(!daily)missing.push('Labelled daily serving');
  if(!fields.ingredients)missing.push('Active ingredients and amounts');
  if(!fields.otherIngredients||/see |not shown|consult /i.test(fields.otherIngredients))missing.push('Complete other ingredients');
  if(!fields.warnings)missing.push('Warnings');if(!fields.storage)missing.push('Storage');
  if(fields.shipping===null)missing.push('Delivery charge');
  const checkedAt=new Date().toISOString();
  if(reviewed&&!product&&!structured){
    fields.price=null;fields.available=null;fetchFailed=true;
    if(!missing.includes('Current price'))missing.unshift('Current price');
    notes.push('The seller returned no readable product data. Current price and availability could not be confirmed.');
  }
  return {ok:true,sourceUrl:url,sourceLinks,checkedAt,reviewedAt:reviewed?.reviewedAt||null,mode:fetchFailed?'reviewed-only':reviewed?'live-price-reviewed-label':'automatic',fields,missing,notes,priceSource,
    selectedVariant:selected?String(selected.id):null,
    variants:variants.map(v=>({id:String(v.id),title:plainText(v.title).slice(0,100)})),
    comparisonUrl:reviewed?`https://gopryme.com/pages/supplement-comparison-singapore#${reviewed.category}`:null};
}

window.PrymeLabelParser = {extractLabelText};
})();
